module.exports = __webpack_public_path__ + "static/media/phone.d5011bbf.svg";